import http from "./http_common";

class AuthService {
  TokenAuthentication(payload){
    var queryString = Object.keys(payload).map((key) => key + "=" + payload[key]).join("&");
    return http.get(`/oauth/token?${queryString}`);
  }

  Login(data){
      return http.post('/Login/patient-login',data) 
  }

  doctorLogin(data){
    return http.post('/Login/',data) 
  }

  changePassword(payload){
    return http.post('/password-config/change-password/',payload);
  }

  forgetPassword(payload){
    return http.post('/password-config/otpforgetpassword',payload);
  }

  patForgetPassword(payload) {
    return http.post("/patientpassword-config/otpforgetpassword", payload);
  }

  patVerifyPassword(payload) {
    return http.post("/patientpassword-config/verifyforgetOTP", payload);
  }

  patUpdatePassword(payload) {
    return http.post("/patientpassword-config/updatePassword/", payload);
  }

  verifyPassword(payload){
    return http.post('/password-config/verifyforgetOTP/',payload);
  }

  patientMobNumChangeOtp(payload){
    return http.post('/PatientOTP/generateOTP',payload);
  }

  patientMobNumVerifyOtp(payload){
    return http.post('/PatientOTP/verifyOTP',payload);
  }

  getPatientMobileOtp(payload){
    return http.post('/PatientOTP/generatePatientOTP',payload);
  }

  getUserMobileOtp(payload){
    return http.post('/UserOTP/generateUserOTP',payload);
  }
  

  verifyPatientOtp(payload){
    return http.post('/PatientOTP/verifyPatientOTP',payload);
  }

  updatePassword(payload){
    return http.post('/password-config/updatePassword/',payload);
  }

  
}

export default new AuthService();
